import { apiGet, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "ADMIN/EDIT_USER";

const ActionTypes = {
  GetUser: `${NAMESPACE}/GET_USER`,
  SaveUser: `${NAMESPACE}/SAVE_USER`,
};

export const getUser = () => apiGet(ActionTypes.GetUser, `users/me`);

export const saveUser = ({ ...data }, { avatarFile, avatarData }) => {
  const avatarObject = !avatarData
    ? null
    : {
        name: avatarFile.name,
        content: avatarData.split(",")[1],
        size: avatarFile.size,
        contentType: avatarFile.type,
      };
  return apiPut(
    ActionTypes.SaveUser,
    `users/me`,
    {
      avatar: avatarObject,
      ...data,
    },
    { preventErrorNotification: true },
  );
};
